// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.removeButton_c4hhd {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #ef4444;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  padding: 0;
  color: white;
}

.removeButton_c4hhd:hover {
  background-color: #dc2626;
  transform: scale(1.05);
}

.removeButton_c4hhd:active {
  transform: scale(0.95);
}

.removeIcon_CjOd_ {
  flex-shrink: 0;
} `, "",{"version":3,"sources":["webpack://./src/components/shared/RemoveButton/RemoveButton.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".removeButton {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #ef4444;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  padding: 0;\n  color: white;\n}\n\n.removeButton:hover {\n  background-color: #dc2626;\n  transform: scale(1.05);\n}\n\n.removeButton:active {\n  transform: scale(0.95);\n}\n\n.removeIcon {\n  flex-shrink: 0;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"removeButton": `removeButton_c4hhd`,
	"removeIcon": `removeIcon_CjOd_`
};
export default ___CSS_LOADER_EXPORT___;
